import React, { ReactNode } from 'react'

type BadgeTextProps = {
  x: number | string
  y: number | string
  fontSize: number | string
  fill: string
  children: ReactNode
}

export const BadgeText = ({ x, y, fontSize, fill, children }: BadgeTextProps) => (
  <text
    x={x}
    y={y}
    textAnchor="middle"
    dominantBaseline="central"
    fontSize={fontSize}
    fontWeight={600}
    fontFamily="IBM Plex Sans, sans-serif"
    fill={fill}
  >
    {children}
  </text>
)
